import { LOWER_BUDGET_RANGE_LIMITS } from "../constants";
export const validBudgetObject = {
  isValid: true,
  message: "",
};

/**
 * returns whether the lower budget limit is valid
 * @param {number} lowerBudgetLimit
 */
export const validateLowerLimit = lowerBudgetLimit => {
  lowerBudgetLimit = lowerBudgetLimit || 0;
  let lowerBudgetValue = Number(lowerBudgetLimit);
  if (isNaN(lowerBudgetValue)) {
    return {
      isValid: false,
      message: "Invalid Amount",
    };
  }
  if (lowerBudgetValue > LOWER_BUDGET_RANGE_LIMITS.max) {
    return {
      isValid: false,
      message: "Please enter min amount less than 20L",
    };
  }
  return validBudgetObject;
};
/**
 * returns whether the upper budget limit is valid
 * @param {number} lowerBudgetLimit
 * @param {number} upperBudgetLimit
 */
export const validateUpperLimit = (lowerBudgetLimit, upperBudgetLimit) => {
  if (
    (upperBudgetLimit &&
      lowerBudgetLimit &&
      Number(lowerBudgetLimit) > Number(upperBudgetLimit)) ||
    upperBudgetLimit < 0
  ) {
    return {
      isValid: false,
      message: `Please enter maximum greater than ${lowerBudgetLimit}L`,
    };
  }
  return validBudgetObject;
};
